"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoTypeIsPercentage = void 0;
var constants_1 = require("./constants");
var promoTypeIsPercentage = function (promotion) {
    return promotion && promotion.type === constants_1.promoTypes.PERCENTAGE;
};
exports.promoTypeIsPercentage = promoTypeIsPercentage;
